export var ShapeCroper;
(function (ShapeCroper) {
    ShapeCroper["rect"] = "rect";
    ShapeCroper["round"] = "round";
})(ShapeCroper || (ShapeCroper = {}));
